import { OrderItem, OrderItemClaim } from '@mews-commander/data-access';
import { getOrderItemMultiplier } from '@mews-commander/legacy-entities/src/ducks/orderItemNew';
import { ProductData } from '../../../types';
import { getOrderItemAgeCategoryIdentifier } from '../../../utils/ageCategories';
import { COUNTER_NAME_CONCAT_CHARACTER } from './constants';

export const getOrderItemClaims = (
    values: Record<string, number>,
    productsData: ProductData[],
    isProductServiceOrder: boolean,
    defaultAgeCategoryId?: string
): OrderItemClaim[] =>
    Object.entries(values).flatMap(([key, count]) => {
        const [productId, ageCategoryIdentifier] = key.split(COUNTER_NAME_CONCAT_CHARACTER);

        const orderItems = productsData.find(({ data }) => data.id === productId)?.orderItems;

        if (!orderItems) {
            return [];
        }

        const filterByAgeCategory = getFilterByAgeCategoryFunc(
            ageCategoryIdentifier,
            isProductServiceOrder,
            defaultAgeCategoryId
        );

        let alreadyAddedOrderItemsCount = 0;

        return orderItems.filter(filterByAgeCategory).map((orderItem) => {
            if (alreadyAddedOrderItemsCount === count) {
                return { orderItemId: orderItem.id, claimedCount: 0 };
            }

            const orderItemCount = getOrderItemMultiplier(orderItem);

            const claimedCount =
                alreadyAddedOrderItemsCount + orderItemCount <= count
                    ? orderItemCount
                    : count - alreadyAddedOrderItemsCount;
            alreadyAddedOrderItemsCount += claimedCount;

            return { orderItemId: orderItem.id, claimedCount };
        });
    });

const getFilterByAgeCategoryFunc =
    (ageCategoryIdentifier: string, isProductServiceOrder: boolean, defaultAgeCategoryId?: string) =>
    (orderItem: OrderItem) =>
        getOrderItemAgeCategoryIdentifier(orderItem, isProductServiceOrder, defaultAgeCategoryId) ===
        ageCategoryIdentifier;
